export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: '',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'username',
    sortable: true,
    sortField: 'username',
    label: 'field.username',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'amount',
    label: 'field.amount',
    tdClass: 'text-right',
  },
  {
    key: 'paybackOption',
    label: 'field.period',
    tdClass: 'text-capitalize',
  },
  {
    key: 'fromDate',
    label: 'field.fromDate',
  },
  {
    key: 'toDate',
    label: 'field.toDate',
  },
  {
    key: 'createdAt',
    sortable: true,
    sortField: 'createdAt',
    label: 'field.createDate',
  },
  {
    key: 'remark',
    label: 'field.remark',
  },
]
